import Vue from 'vue'
import Router from 'vue-router'

import Livreurs from '../components/agents/Livreurs'
import Receptionnistes from '../components/agents/Receptionnistes'
import CommandesAnnulees from '../components/commandes_annulees/CommandesAnnulees'
import CommandesEncours from '../components/commandes_encours/CommandesEncours'
import CommandesLivraison from '../components/commandes_livraison/CommandesLivraison'
import CommandesRetournees from '../components/commandes_retournes/CommandesRetournees'
import CommandesValidees from '../components/commandes_validees/CommandesValidees'
import MessageContact from '../components/messages/MessageContact'
import MessageMail from '../components/messages/MessageMail'
import MessageFaq from '../components/messages/MessageFaq'
import ProduitsDisponible from '../components/produits_disponible/ProduitsDisponible'
import ProduitsCollectes from '../components/produits_collectes/ProduitsCollectes'
import ProduitsSupprimes from '../components/produits_supprimes/ProduitsSupprimes'
import ProduitsVendus from '../components/produits_vendus/ProduitsVendus'
import Accueil from '../components/Accueil'
import Acheteurs from '../components/acheteurs/Acheteurs'
import Actualites from '../components/actualites/Actualites'
import Administrateurs from '../components/administrateurs/Administrateurs'
import Annonces from '../components/annonces/Annonces'
import AvisClients from '../components/avis_clients/AvisClients'
import CategoriesProduits from '../components/categories_produits/CategoriesProduits'
import Faq from '../components/faq/Faq'
import Promotions from '../components/promotions/Promotions'
import Remboursements from '../components/remboursements/Remboursements'
import SuggestionsAnnonces from '../components/suggestions_annonces/SuggestionsAnnonces'
import SuperUtilisateurs from '../components/super_utilisateurs/SuperUtilisateurs'
import Transactions from '../components/transactions/Transactions'
import Utilisateurs from '../components/utilisateurs/Utilisateurs'
import Vendeurs from '../components/vendeurs/Vendeurs'


Vue.use(Router)

export default new Router({
  routes: [
    { path: '/', name: 'Accueil', component: Accueil },
    { path: '/livreurs', name: 'Livreurs', component: Livreurs },
    { path: '/receptionnistes', name: 'Receptionnistes', component: Receptionnistes },
    { path: '/commandes-annulees', name: 'CommandesAnnulees', component: CommandesAnnulees },
    { path: '/commandes-encours', name: 'CommandesEncours', component: CommandesEncours },
    { path: '/commandes-livraison', name: 'CommandesLivraison', component: CommandesLivraison },
    { path: '/commandes-retournees', name: 'CommandesRetournees', component: CommandesRetournees },
    { path: '/commandes-validees', name: 'CommandesValidees', component: CommandesValidees },
    { path: '/message-contact', name: 'MessageContact', component: MessageContact },
    { path: '/message-mail', name: 'MessageMail', component: MessageMail },
    { path: '/message-faq', name: 'MessageFaq', component: MessageFaq },
    { path: '/produits-encours', name: 'ProduitsDisponible', component: ProduitsDisponible },
    { path: '/produits-collectes', name: 'ProduitsCollectes', component: ProduitsCollectes },
    { path: '/produits-supprimes', name: 'ProduitsSupprimes', component: ProduitsSupprimes },
    { path: '/produits-vendus', name: 'ProduitsVendus', component: ProduitsVendus },
    { path: '/acheteurs', name: 'Acheteurs', component: Acheteurs },
    { path: '/actualites', name: 'Actualites', component: Actualites },
    { path: '/administrateurs', name: 'Administrateurs', component: Administrateurs },
    { path: '/annonces', name: 'Annonces', component: Annonces },
    { path: '/avis-clients', name: 'AvisClients', component: AvisClients },
    { path: '/categories-produits', name: 'CategoriesProduits', component: CategoriesProduits },
    { path: '/faq', name: 'Faq', component: Faq },
    { path: '/promotions', name: 'Promotions', component: Promotions },
    { path: '/remboursements', name: 'Remboursements', component: Remboursements },
    { path: '/suggestions-annonces', name: 'SuggestionsAnnonces', component: SuggestionsAnnonces },
    { path: '/super-utilisateurs', name: 'SuperUtilisateurs', component: SuperUtilisateurs },
    { path: '/transactions', name: 'Transactions', component: Transactions },
    { path: '/utilisateurs', name: 'Utilisateurs', component: Utilisateurs },
    { path: '/vendeurs', name: 'Vendeurs', component: Vendeurs },
  ],
  mode: 'history',
})



// WEBPACK FOOTER //
// ./src/router/index.js